<template>
  <div>
    <header>
      <div class="header-top">
        <div class="container">
          <a href="tel:(11)3670-4400">(11) 3670-4400</a>
          <a href="mailto:contato@fastlube.com.br">contato@fastlube.com.br</a>
          <a href="/"><img class="flag" src="../../static/images/brasil.png" style="border-radius: 5px; height: 20px;" alt></a>
        </div>
      </div>
      <nav class="navbar navbar-expand-lg navbar-dark">
        <div class="container">
          <router-link to="/">
            <a class="navbar-brand logo">
              <img src="../../static/images/logo.png" alt="Japanparts">
            </a>
          </router-link>
          <button
            class="navbar-toggler collapsed ml-auto"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <div class="navbar-handle">
              <span class="bar"></span>
              <span class="bar"></span>
              <span class="bar"></span>
            </div>
          </button>
          <div class="navbar-collapse collapse" id="navbarCollapse">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item active">
                <router-link to="/">
                  <a class="nav-link" :class="{ active: pageName == 'Home' }">HOME</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/sobre">
                  <a class="nav-link" :class="{ active: pageName == 'About' }" >QUEM SOMOS</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/produtos">
                  <a class="nav-link" :class="{ active: pageName == 'Products' }" >PRODUTOS</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/lancamentos">
                  <a class="nav-link" :class="{ active: pageName == 'Releases' }">LANÇAMENTOS</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/dicas">
                  <a class="nav-link" :class="{ active: pageName == 'Tips' }">DICAS TÉCNICAS</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/contato">
                  <a class="nav-link" :class="{ active: pageName == 'Contact' }">CONTATO</a>
                </router-link>
              </li>
              <li class="nav-item social">
                <a href="https://www.facebook.com/FastLubeOficialJapanparts/" target="_blank">
                  <i class="icon-facebook"></i>
                </a>
                <a href="https://www.instagram.com/fastlubejapanparts/" target="_blank">
                  <i class="icon-instagram"></i>
                </a>
                <a href="https://www.youtube.com/fastlubefiltrosautomotivosjapanparts" target="_blank">
                  <i class="icon-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
import Session from "@/api/session.vue";

export default {
  name: "Header",
  mounted() {
    this.getPage();
  },
  data() {
    return {
      page: "",
      logged: false,
      pageName: ''
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      this.logged = Session.isActive();
      this.pageName = this.$route.name;
    }
  },
  methods: {
    getPage(){
      this.pageName = this.$route.name;
    }
  }
};
</script>

<style lang="scss" scoped>
a:hover {
  color: #f3d22b !important;
}
</style>

<style lang="scss">
.active {
  color: #f3d22b !important;
}
a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue